module.exports = __webpack_public_path__ + "static/media/010.81f6bc50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/010.jpg
// module id = 483
// module chunks = 0